import { ErrorOutline24Icon } from "@vygruppen/spor-icon-react";
import { useTranslation } from "react-i18next";
import { Box, BoxProps, TextLink } from "shared/components/Spor";
import { Message } from "shared/components/feedback/FailureMessage/styles";
import { FCWC } from "shared/utils/FCWC";
import styled from "styled-components";

interface FailureMessageProps extends BoxProps {
  customMessage?: string;
}

const Wrapper = styled(Box)`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 6px;
  align-items: center;
  max-width: 483px;
  margin: auto;

  & :nth-child(1) {
    grid-row: 1;
  }

  & :nth-child(2) {
    grid-row: 1 / span 2;
  }
`;

export const FailureMessage: FCWC<FailureMessageProps> = ({
  customMessage,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <Wrapper data-testid="failureMessage" alignContent="center" {...props}>
      <ErrorOutline24Icon />
      <Message>
        {customMessage || (
          <>
            {t(
              "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Ta kontakt med IT",
            )}
            <TextLink
              href="mailto:team-brukerflater-drops@vy.no?cc=vygruppen@service-now.com"
              target="_blank"
              rel="noopener noreferer"
              style={{ margin: "0 0.5ch", display: "inline" }}
            >
              {t("her")}
            </TextLink>
            {t("hvis feilen vedvarer.")}
          </>
        )}
      </Message>
    </Wrapper>
  );
};
